import { z } from 'zod'
import { HUES } from '@/lib/colour'

export const PROJECT_STATES = ['active', 'paused', 'done', 'dropped'] as const
export type ProjectState = (typeof PROJECT_STATES)[number]

export const projectSpec = z
  .object({
    title: z.string().min(1, 'title is required').max(500),
    icon: z.string().max(40).optional(),
    colour: z.enum(HUES).optional(),
    notes: z.string().optional(),
    outcome: z.string().optional(),
    due: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'use YYYY-MM-DD')
      .optional(),
    remind_at: z.string().optional(),
    /** shows as an app on the phone (launcher, Home, dock), like a pinned list */
    pinned: z.boolean().optional(),
    repos: z.array(z.string().max(200)).optional(),
  })
  .strict()
export type ProjectSpec = z.infer<typeof projectSpec>

export const projectStatus = z.object({
  state: z.enum(PROJECT_STATES),
  open_tasks: z.number().int().default(0),
  done_tasks: z.number().int().default(0),
  next_task_id: z.string().optional(),
  last_touched: z.string(),
  reminder_fired_for: z.string().optional(),
  completed_at: z.string().optional(),
  /** what this project became (task, page); it is dropped with it */
  converted_to: z.object({ kind: z.string(), id: z.string() }).strict().optional(),
})
export type ProjectStatus = z.infer<typeof projectStatus>

export const isProjectOpen = (state: string) => state === 'active' || state === 'paused'
